<template>
  <div class="modern-page">
    <hatadialog ref="hatadialog"></hatadialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>

    <!-- IBAN GÜNCELLE -->
<v-dialog v-model="IBANDialog" persistent max-width="450">
  <v-dialog v-model="dialogsorIBAN" persistent max-width="290">
    <v-card class="dialog-card">
      <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
      <v-card-text>{{ $t('Are-you-sure-want-delete') }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="info" flat @click.native="dialogsorIBAN=false">{{$t("cancel_button")}}</v-btn>
        <v-btn color="info" flat @click="IBANSil()">{{ $t('OK') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-card class="dialog-card">
    <v-card-title class="headline">{{ $t('IBAN-Info')}}</v-card-title>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 sm12 md6>
          <v-text-field
            class="modern-field"
            hide-details
            label="IBAN"
            v-model="guncelleIBAN.IBAN"
            maxlength="28"
            outlined
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm12 md3>
          <v-text-field
            class="modern-field"
            hide-details
            label="Sort Code"
            v-model="guncelleIBAN.SortCode"
            maxlength="20"
            outlined
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm12 md3>
          <v-text-field
            class="modern-field"
            hide-details
            label="Acc No"
            v-model="guncelleIBAN.AccNo"
            maxlength="34"
            outlined
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm12 md12>
          <v-textarea
            class="modern-field"
            maxlenght="250"
            hide-details
            :label="$t('Description')"
            v-model="guncelleIBAN.Description"
            outlined
          ></v-textarea>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" flat @click="IBANDialog=false">{{ $t('cancel_button')}}</v-btn>
      <v-btn color="primary" flat @click="IBANGuncelle()">{{ $t('save_button')}}</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    <v-dialog v-if="videodialog" v-model="videodialog" max-width="800px">
      <v-card class="dialog-card">
        <v-card-text>
          <iframe
            width="100%"
            height="500"
            src="https://www.youtube.com/embed/3Ve0qSD3R5c?list=PLIeHwLek0GOeIoIUwHSUXZpnvX2Al8l3g"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          ></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card class="page-shell" flat>
      <v-form ref="formcurrent" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <div class="hero-bar">
              <div>
                <div class="hero-badge">{{$t('Customer-Account')}}</div>
                <h1 class="hero-title">{{ $t('current_index_addbuton_label') }}</h1>
              </div>

              <div class="hero-actions">
                <v-checkbox
                  :label="this.$t('Save-in-All-Companies')"
                  v-model="tumsirketler"
                  hide-details
                  class="hero-checkbox"
                ></v-checkbox>

                <v-btn @click="ekle()" class="save-btn" depressed>
                  <span>{{$t('save_button')}}</span>
                  <v-icon right dark>add_box</v-icon>
                </v-btn>

                <v-menu bottom>
                  <v-btn slot="activator" class="icon-btn" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>

                  <v-list>
                    <a target="_self" v-bind:href="'#/cari/index/'">
                      <v-list-tile>
                        <v-list-tile-title>{{$t('cancel_button')}}</v-list-tile-title>
                      </v-list-tile>
                    </a>
                  </v-list>

                  <v-list>
                    <v-list-tile @click="videoac()">
                      <v-list-tile-title>{{ $t('How-to-do') }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </v-flex>

          <v-flex xs12>
            <v-tabs class="modern-tabs" v-model="active" color="transparent" slider-color="#2563eb">
              <v-tabs-slider></v-tabs-slider>

              <!-- GENEL -->
              <v-tab href="#0">{{$t("tab_general")}}</v-tab>
              <v-tab-item :id="'0'" class="tab-pane">
                <v-layout row wrap>
                  <v-flex pa-2 xs12 sm6 md6>
                    <v-card class="content-card" flat>
                      <div class="section-head">
                        <h3>{{ $t('General-Information') }}</h3>
                      </div>

                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex xs12 md8>
                            <v-text-field
                              class="modern-field"
                              :label="'Customer Kod'"
                              @blur="checkCode()"
                              maxlength="15"
                              v-model="Current.Code"
                              :error-messages="errors.collect('carikod')"
                              v-validate="'required'"
                              hide-details
                              data-vv-name="carikod"
                              required
                              outlined
                            >
                              <template v-slot:prepend>
                                <v-icon color="info" @click="getCariDialog()">search</v-icon>
                              </template>
                            </v-text-field>
                          </v-flex>

                          <v-flex xs12 md4>
                            <div class="last-code-wrap">
                              <v-btn outline @click="soncarikoduGetir()" color="info">
                                {{ $t('View-Last-Current-Code') }}
                              </v-btn>
                            </div>
                          </v-flex>

                          <v-flex xs12 md12>
                            <v-text-field
                              class="modern-field"
                              hide-details
                              :label="$t('Name')"
                              maxlength="100"
                              v-model="Current.Title"
                              :error-messages="errors.collect('unvan')"
                              v-validate="'required'"
                              data-vv-name="unvan"
                              required
                              outlined
                            ></v-text-field>
                          </v-flex>

                          

                         

                          <v-flex xs12 md6>
                            <v-select
                              class="modern-field"
                              :items="currentTypeItems"
                              hide-details
                              v-model="Current.Type"
                              item-text="text"
                              item-value="value"
                              :label="'Type'"
                              outlined
                            ></v-select>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-select
                              class="modern-field"
                              :items="musteritipi"
                              hide-details
                              v-model="Current.CustomerType"
                              item-text="text"
                              item-value="value"
                              clearable
                              :label="$t('Customertype_label')"
                              outlined
                            ></v-select>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              class="modern-field"
                              hide-details
                              :label="$t('Phonenumber_label')"
                              maxlength="15"
                              v-model="Current.Phone1"
                              outlined
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              class="modern-field"
                              hide-details
                              :label="$t('Email_label')"
                              v-model="Current.Email"
                              outlined
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              class="modern-field"
                              hide-details
                              :label="$t('Web-Address')"
                              v-model="Current.Web"
                              outlined
                            ></v-text-field>
                          </v-flex>

                          
                          <v-flex xs12 md6>
  <v-select
    class="modern-field"
    :items="caritipi"
    hide-details
    v-model="Current.Buyer_Seller"
    item-text="text"
    item-value="value"
    clearable
    :label="$t('Current-Type')"
    outlined
  ></v-select>
</v-flex>
                          
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <v-flex pa-2 xs12 sm6 md6>
                    <v-card class="content-card" flat>
                      <div class="section-head">
                        <h3>{{ $t('Note-Sections') }}</h3>
                      </div>

                      <v-card-text>
                        <v-layout justify-space-between column>
                          <v-textarea
                            class="modern-field"
                            v-model="Current.InfoNote"
                            :label="$t('Infonote_label')"
                            outlined
                          ></v-textarea>

                          <v-textarea
                            class="modern-field"
                            v-model="Current.WarningNote"
                            :label="$t('Warningnote_label')"
                            outlined
                          ></v-textarea>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-tab-item>

              <!-- FATURA -->
              <v-tab href="#1" ripple>
                {{ $t('tab_invoiceinformation') }}
              </v-tab>

              <v-tab-item :id="'1'" class="tab-pane">
                <v-layout row wrap>
                  <!-- FATURA ADRES -->
                  <v-flex pa-2 xs12 :md="isDomestic ? 4 : 12">
                    <v-card class="content-card" flat>
                      <div class="section-head">
                        <h3>{{ $t('Billing-Adress-Details') }}</h3>
                      </div>

                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-textarea
                              class="modern-field"
                              hide-details
                              no-resize
                              v-model="Current.Invoice.Address"
                              :label="$t('Address_label')"
                              outlined
                            ></v-textarea>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              class="modern-field"
                              hide-details
                              :label="$t('District')"
                              v-model="Current.Invoice.District"
                              outlined
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              class="modern-field"
                              hide-details
                              :label="$t('City')"
                              v-model="Current.Invoice.City"
                              outlined
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-combobox
                              class="modern-field"
                              v-model="Current.Invoice.Country"
                              :items="ulkeTipi"
                              :label="$t('Country_label')"
                              outlined
                            ></v-combobox>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              class="modern-field"
                              hide-details
                              :label="$t('Postcode_label')"
                              v-model="Current.Invoice.PostCode"
                              outlined
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              class="modern-field"
                              hide-details
                              :label="$t('Taxnumber_label')"
                              v-model="Current.Invoice.TaxNumber"
                              outlined
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              class="modern-field"
                              hide-details
                              :label="$t('Taxcenter_label')"
                              v-model="Current.Invoice.TaxOffice"
                              outlined
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 v-if="isDomestic && PB=='TRY'">
                            <v-checkbox
                              class="modern-check"
                              :label="$t('Dontbebilled_label')"
                              v-model="biletlerfaturalanmasin"
                              hide-details
                            ></v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <!-- TC KİMLİK BİLGİLERİ -->
                  <v-flex v-if="isDomestic && PB=='TRY'" pa-2 xs12 md4>
                    <v-card class="content-card" flat>
                      <div class="section-head">
                        <h3>{{ $t('For-Transactions-With-TC-ID') }}</h3>
                      </div>

                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-text-field
                              class="modern-field"
                              hide-details
                              :label="$t('Identitynumber_label')"
                              mask="###########"
                              v-model="Current.Invoice.IdentityNumber"
                              outlined
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12>
                            <v-text-field
                              class="modern-field"
                              hide-details
                              :label="$t('Name_label')"
                              v-model="Current.Invoice.PerFirstName"
                              outlined
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12>
                            <v-text-field
                              class="modern-field"
                              hide-details
                              :label="$t('Surname_label')"
                              v-model="Current.Invoice.PerFamilyName"
                              outlined
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12>
                            <v-text-field
                              class="modern-field"
                              hide-details
                              :label="$t('Title_label')"
                              v-model="Current.Invoice.PerTitle"
                              outlined
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12>
                            <v-text-field
                              class="modern-field"
                              hide-details
                              :label="$t('Othername_label')"
                              v-model="Current.Invoice.PerMiddleName"
                              outlined
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12>
                            <v-text-field
                              class="modern-field"
                              hide-details
                              :label="$t('Suffixname_label')"
                              v-model="Current.Invoice.PerNameSuffix"
                              outlined
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12>
                            <v-text-field
                              class="modern-field"
                              hide-details
                              label="Passport Number"
                              maxlength="9"
                              v-model="Current.Invoice.PassportNumber"
                              outlined
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <!-- E-FATURA -->
                  <v-flex v-if="isDomestic && PB=='TRY'" pa-2 xs12 md4>
                    <v-card class="content-card" flat>
                      <div class="section-head">
                        <h3>{{ $t('E-Invoice-Taxpayer-Information') }}</h3>
                      </div>

                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-select
                              class="modern-field"
                              hide-details
                              :items="efaturatipi"
                              v-model="Current.EInvoiceType"
                              item-text="text"
                              item-value="value"
                              :label="$t('E-invoicetype')"
                              outlined
                            ></v-select>
                          </v-flex>

                          <v-flex xs12>
                            <v-text-field
                              v-if="cokluposta==false"
                              class="modern-field"
                              hide-details
                              :label="$t('Post-Label')"
                              v-model="Current.PostCodeLabel"
                              outlined
                            ></v-text-field>

                            <v-select
                              v-if="cokluposta==true"
                              class="modern-field"
                              :items="postaitems"
                              hide-details
                              v-model="Current.PostCodeLabel"
                              clearable
                              :label="$t('Post-Label')"
                              outlined
                            ></v-select>
                          </v-flex>

                          <v-flex xs12>
                            <v-checkbox
                              class="modern-check"
                              :label="$t('E-invoicetypeamenable_label')"
                              v-model="efaturamukellefi"
                              hide-details
                            ></v-checkbox>
                          </v-flex>

                          <v-flex xs12>
                            <v-checkbox
                              class="modern-check"
                              :label="$t('Usingmultiplemail_label')"
                              v-model="Current.MultiPostUse"
                              hide-details
                            ></v-checkbox>
                          </v-flex>

                          <v-flex xs12>
                            <v-btn
                              v-if="!mukellefScroll"
                              small
                              depressed
                              color="info"
                              class="query-btn"
                              @click="mukellefSorgula()"
                            >
                              {{ $t('Inquire-Liables') }}
                              <v-icon right>search</v-icon>
                            </v-btn>

                            <v-progress-linear
                              v-if="mukellefScroll"
                              color="red"
                              indeterminate
                              rounded
                              height="6"
                            ></v-progress-linear>
                          </v-flex>

                          <v-flex xs12 class="mt-3">
                            <v-select
                              class="modern-field"
                              hide-details
                              :items="islembilgileri"
                              v-model="Current.EArchiveSendType"
                              item-text="text"
                              item-value="value"
                              :label="$t('E-archiveprocessinformationtype_label')"
                              outlined
                            ></v-select>
                          </v-flex>

                          <v-flex xs12>
                            <v-checkbox
                              class="modern-check"
                              :label="$t('Printonpaperinsteadofe-archive')"
                              v-model="Current.EArchiveSendPaper"
                              hide-details
                            ></v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-tab-item>

              <!-- SERVİS ÜCRETİ -->
              <v-tab href="#2" ripple>
                {{$t('Service-Fee')}}
              </v-tab>

              <v-tab-item :id="'2'" class="tab-pane">
                <v-layout row wrap>
                  <v-flex pa-2 xs12 sm12 md6>
                    <v-card class="content-card" flat>
                      <div class="section-head">
                        <h3>{{ $t('Domestic-Line-Service-Fees') }}</h3>
                        <span>{{ $t('Domestic-Service-Fee') }}</span>
                      </div>

                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex xs12 sm8 md8>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-layout>
                                  <v-flex xs12 sm2 md2>
                                    <v-layout align-center fill-height>
                                      <v-chip color="red" label>
                                        <span class="white--text">11-</span>
                                      </v-chip>
                                    </v-layout>
                                  </v-flex>

                                  <v-flex xs12 sm4 md4>
                                    <parainput
                                      v-model="ServisParametre.Fiyat11"
                                      :id="'Fiyat11'"
                                      :etiket="$t('Domestic-Line')"
                                      :simge="getparabirimi()"
                                      :autocomplete="'autocomplete'"
                                    ></parainput>
                                  </v-flex>

                                  <v-flex xs12 sm5 md5>
                                    <v-autocomplete
                                      id="doviz11"
                                      v-model="ServisParametre.Doviztip11"
                                      hide-details
                                      :items="doviztipi"
                                      clearable
                                      item-text="Title"
                                      item-value="DovizKod"
                                      :label="$t('Currency-Type')"
                                      outlined
                                      class="modern-field"
                                    ></v-autocomplete>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm4 md4>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-checkbox v-model="icYuzdedenHesapla.Yuzdeden" :label="$t('Domestic-Lines-Calculation')" hide-details class="modern-check"></v-checkbox>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                <v-select hide-details v-if="icyuzde" v-model="icYuzdedenHesapla.HesapTipi" :items="hesaptipi" item-text="text" item-value="value" :label="$t('Account-Type')" outlined class="modern-field"></v-select>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                <yuzdeinput :etiket="$t('Percentage') + '%'" v-if="icyuzde" v-model="icYuzdedenHesapla.HesapYuzde" :autocomplete="'autocomplete'"></yuzdeinput>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <v-flex pa-2 xs12 sm12 md6>
                    <v-card class="content-card" flat>
                      <div class="section-head">
                        <h3>{{$t('International-Lines-Service-Prices')}}</h3>
                        <span>{{ $t('International-Service-Fee') }}</span>
                      </div>

                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex xs12 sm8 md8>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-layout>
                                  <v-flex xs12 sm2 md2>
                                    <v-layout align-center fill-height>
                                      <v-chip color="info" label>
                                        <span class="white--text">21-</span>
                                      </v-chip>
                                    </v-layout>
                                  </v-flex>

                                  <v-flex xs12 sm5 md5>
                                    <parainput
                                      :etiket="$t('International-Line')"
                                      :simge="getparabirimi()"
                                      v-model="ServisParametre.Fiyat21"
                                      :autocomplete="'autocomplete'"
                                    ></parainput>
                                  </v-flex>

                                  <v-flex xs12 sm5 md5>
                                    <v-autocomplete
                                      hide-details
                                      :items="doviztipi"
                                      v-model="ServisParametre.Doviztip21"
                                      clearable
                                      item-text="Title"
                                      item-value="DovizKod"
                                      :label="$t('Currency-Type')"
                                      outlined
                                      class="modern-field"
                                    ></v-autocomplete>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm4 md4>
                            <v-layout align-content-start fill-height row wrap>
                              <v-flex xs12 sm6 md12>
                                <v-checkbox v-model="DisYuzdedenHesapla.Yuzdeden" :label="$t('International-Line-Calculation')" hide-details class="modern-check"></v-checkbox>
                              </v-flex>
                              <v-flex xs12 sm6 md12>
                                <v-select hide-details v-if="disyuzde" v-model="DisYuzdedenHesapla.HesapTipi" :items="hesaptipi" item-text="text" item-value="value" :label="$t('Account-Type')" outlined class="modern-field"></v-select>
                              </v-flex>
                              <v-flex xs12 sm6 md12>
                                <yuzdeinput :etiket="$t('Percentage') + '%'" v-if="disyuzde" v-model="DisYuzdedenHesapla.HesapYuzde" :autocomplete="'autocomplete'"></yuzdeinput>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-tab-item>

              

              

              <!-- NOTLAR -->
              <v-tab href="#4" ripple>
                {{$t('Notes')}}
              </v-tab>

              <v-tab-item :id="'4'" class="tab-pane">
                <v-flex pa-2 xs12 sm12 md12>
                  <v-card class="content-card" flat>
                    <div class="section-head">
                      <h3>{{ $t('Notes') }}</h3>
                    </div>

                    <v-card-text>
                      <v-textarea class="modern-field" hide-details v-model="Current.Explanations" :label="$t('Notes')" outlined></v-textarea>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-tab-item>

              <!-- BANKA -->
<v-tab href="#6" ripple>
  {{$t('Bank-Info')}}
</v-tab>

<v-tab-item :id="'6'" class="tab-pane">
  <v-form ref="formbanka" v-model="validbanka" lazy-validation>
    <v-flex pa-2 xs12 sm12 md12>
      <v-card class="content-card" flat>
        <div class="section-head">
          <h3>{{ $t('Bank-Details') }}</h3>
          <span>{{ $t('IBAN-Referance-Management') }}</span>
        </div>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 pt-2 pb-2 sm12 md12>
              <v-card flat class="sub-card">
                <v-layout pa-2 row wrap>
                  <v-flex xs12 sm12 md12>
                    <span class="font-weight-regular grey--text subheading">{{ $t('IBAN') }}</span>
                    <v-divider></v-divider>
                  </v-flex>

                  <v-flex xs12 sm12 md3>
                    <v-text-field
                      class="modern-field"
                      :rules="[v => !!v || $t('Mandatory-Areas')]"
                      v-model="IBANAd"
                      label="IBAN"
                      maxlength="28"
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md2>
                    <v-text-field
                      class="modern-field"
                      v-model="IBANSortCode"
                      label="Sort Code"
                      maxlength="20"
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md2>
                    <v-text-field
                      class="modern-field"
                      v-model="IBANAccNo"
                      label="Acc No"
                      maxlength="34"
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md3>
                    <v-text-field
                      class="modern-field"
                      :rules="[v => !!v || $t('Mandatory-Areas')]"
                      v-model="IBANDesc"
                      :label="this.$t('Description')"
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md2>
                    <v-layout align-center fill-height>
                      <v-btn color="info" depressed @click="IBANEkle()">
                        {{this.$t('Add-IBAN')}}
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>

            <v-flex xs12 pt-2 pb-2 sm12 md12>
              <v-card flat class="sub-card">
                <v-layout pa-2 row wrap>
                  <v-flex xs12 pt-2 pb-2 sm12 md12>
                    <span class="font-weight-regular grey--text subheading">{{ $t('IBAN-LIST') }}</span>
                    <v-divider></v-divider>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-card flat>
                      <v-data-table :headers="headersbankinfo" :items="Current.BankInfo" hide-actions class="elevation-1">
                        <template slot="items" slot-scope="props">
                          <tr item v-if="props.item.Silinecek==false">
                            <td class="text-xs-left">{{ props.item.IBAN }}</td>
                            <td class="text-xs-left">{{ props.item.SortCode }}</td>
                            <td class="text-xs-left">{{ props.item.AccNo }}</td>
                            <td class="text-xs-left">{{ props.item.Description }}</td>
                            <td class="text-xs-right">
                              <v-btn icon>
                                <v-icon @click="IBANGuncelleAc(props.item)" color="teal">edit</v-icon>
                              </v-btn>
                              <v-btn @click="IBANSilSor(props.item)" icon>
                                <v-icon color="red">delete</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-form>
</v-tab-item>
            </v-tabs>
          </v-flex>

          <!-- CARİ DİYALOG -->
          <v-dialog v-model="CariDialog" scrollable max-width="500px">
            <v-card class="dialog-card" flat>
              <v-card-title>{{ $t('Find-Current') }}</v-card-title>
              <v-divider></v-divider>

              <v-card-text>
                <v-flex xs12 sm12 md12>
                  <v-card flat>
                    <v-card-title>
                      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="cariSearch"></v-text-field>
                    </v-card-title>

                    <v-data-table :headers="headers" :items="cariItems" :search="cariSearch">
                      <template slot="items" slot-scope="props">
                        <tr @click="selectCari(props.item.Code)">
                          <td class="text-xs-left">{{ props.item.Code }}</td>
                        </tr>
                      </template>

                      <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Your search for "{{ cariSearch }}" found no results.
                      </v-alert>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="CariDialog=false">{{$t('Close')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- VADE TİPİ -->
          <v-dialog v-model="dialogfiltre" scrollable max-width="500px">
            <v-card class="dialog-card" flat>
              <v-card-title>{{ $t('Term-Type-Explanations') }}</v-card-title>
              <v-divider></v-divider>

              <v-card-text>
                <v-flex xs12 sm12 md12>
                  <v-list two-line>
                    <template v-for="(item, index) in vadetipi">
                      <v-subheader v-if="item.header" :key="item.header"></v-subheader>
                      <v-divider v-else-if="item.divider" :key="index" :inset="item.inset"></v-divider>

                      <v-list-tile v-else :key="item.title">
                        <v-list-tile-avatar>{{item.value}}</v-list-tile-avatar>
                        <v-list-tile-content>
                          <span class="caption">{{item.text}}</span>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list>
                </v-flex>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="dialogfiltre=false">{{$t('Close')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import auth from '../../../api/auth'
import parainput from '../customcomp/parainput'
import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue"
import tool from "../coper/tools";
import helpers from "@/components/app/customcomp/helpers.js"
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import cariaracomp from '@/components/app/customcomp/cariaracomp'
import analizcomp from '@/components/app/bilet/partpage/analizcomp'
import loadingcomp from "@/components/app/customcomp/loadingcomp"
import muhasebekoducomp from '@/components/app/customcomp/muhasebekoducomp'
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";

export default {
  data() {
    return {
      valid: true,
validbanka: true,
guncelleIBAN: {
  IBAN: '',
  SortCode: '',
  AccNo: '',
  Description: '',
  Silinecek: false
},
IBANDialog: false,
IBANAd: '',
IBANSortCode: '',
IBANAccNo: '',
IBANDesc: '',
PB: "TRY",
dialogsorIBAN: false,
headersbankinfo: [
  { text: this.$t('IBAN'), value: 'IBAN' },
  { text: 'Sort Code', value: 'SortCode' },
  { text: 'Acc No', value: 'AccNo' },
  { text: this.$t('Description'), value: 'Description' },
],
      headers: [
        { text: "Kod" }
      ],

      tumsirketler: false,
      accounting: false,
      ulkeTipi: [],
      itemsSablon: [],
      itemsSablonSelected: [],
      loadingvmodel: false,
      videodialog: false,
      prevRoute: null,
      mukellefScroll: false,
      hesapgurubu: [],
      dialogfiltre: false,
      cokluposta: false,
      postaitems: [],
      loading: false,

      Current: {
  AliciSatici: 0,
  CompanyCode: '',
  Code: null,
  Title: null,
  Title2: null,

  Phone1: '',
  Phone2: '',
  Mobile: '',

  Web: '',
  Email: '',

  AccountGroup: '',
  Type: 'domestic',
  CMCode: '',

  Reserved1: '',
  Reserved2: '',

  Authorized: '',
  WarningNote: '',
  InfoNote: '',

  AccountingCode: '',
  CustomerType: '',

  TicketBill: '',
  TaxFree: '0',

  EInvoiceType: '0',
  PostCodeLabel: '',
  EInvoiceCustomer: '',
  MultiPostUse: false,
  EArchiveSendType: 'true',
  EArchiveSendPaper: false,

  CreditLimit: 0,
  CreditLimitCurrencyAmount: 0,
  CreditLimitCurrency: '',

  WebPassword: '',
  PinCode: '',
  MileCode: '',
  Bank: '',

  ExpiryDayDomestic: '',
  ExpiryTypeDomestic: '',
  ExpiryDayInt: '',
  ExpiryTypeInt: '',
  ExpiryDayGeneral: '',
  ExpiryTypeGeneral: '',

  DiscountGeneral: '',
  DiscountDom: '',
  DiscountInt: '',
  DiscountDomService: '',
  DiscountIntService: '',

  ExternalCurrentCode: '',
  ExternalAccountingCode: '',
  StreamCurrentCode: '',
  ArkmanStreamCode: '',
  ArkmanStreamPassword: null,

  ExpenseCenter: null,
  TemplateID: '',

  ProfileForced: '',
  EventIDForced: '',

  MainAccount: '',
  Explanations: null,
  AnalysisCode: null,

  PrivateCode5: null,
  PrivateCode6: null,
  PrivateCode7: null,
  PrivateCode8: null,

  PeriodControl: false,

  BankInfo: [],
  CustomReportTemplate: [],

  Invoice: {
    SpendingUnitVKN: '',

    Address: '',
    District: '',
    City: '',
    Province: '',
    Country: '',
    PostCode: '',

    TaxNumber: '',
    TaxOffice: '',

    IdentityNumber: '',

    PerFirstName: '',
    PerFamilyName: '',
    PerTitle: '',
    PerMiddleName: '',
    PerNameSuffix: '',

    NoPrint: '',
    CustomerPersonelNoInvoice: '',

    DeliveryAddress: '',
    DeliveryName: '',

    BuildingNumber: '',

    PassportNumber: ''
  },

  Contract: {
    ContractNumber: '',
    ContractDate: '',
    PaymentType: '',
    BankAccountNumber: '',
    BankBranchOffice: '',
    InvoiceRowNumber: '',
    InvoicePassengerName: '',
    InvoiceFlightNumber: '',

    IadeCariAyrilsin: false,
    IadeCariKod: '',

    Tevkifatli: false,
    TevkifatOrani: null,
    TevkifatKodu: ''
  }
},

      ServisParametre: {
        ServisKod11: 11,
        Doviztip11: null,
        Fiyat11: 0,
        ServisKod21: 21,
        Doviztip21: null,
        Fiyat21: 0,
      },

      hesaptipi: [
        { text: this.$t('Ticket-Amount'), value: 0 },
        { text: this.$t('Ticket-Amount') + '+' + this.$t('Taxes'), value: 1 }
      ],

      icYuzdedenHesapla: {
        Yuzdeden: false,
        HesapTipi: null,
        HesapYuzde: 0
      },

      DisYuzdedenHesapla: {
        Yuzdeden: false,
        HesapTipi: null,
        HesapYuzde: 0
      },

      caritipi: [{
                    text: this.$t('Customer'),
                    value: 0
                },
                {
                    text: this.$t('Supplier'),
                    value: 1
                }, {
                    text: this.$t('Other'),
                    value: 2
                },
            ],

      currentTypeItems: [
        { text: 'Domestic', value: 'domestic' },
        { text: 'International', value: 'international' }
      ],

      musteritipi: [
        { text: this.$t('Individual'), value: 'B' },
        { text: this.$t('Corporate'), value: 'K' },
        { text: this.$t('Public'), value: 'D' },
      ],

      efaturatipi: [
        { text: this.$t('Commercial'), value: '0' },
        { text: this.$t('Basic'), value: '1' },
        { text: this.$t('Export'), value: '2' },
        { text: this.$t('Public'), value: '3' }
      ],

      islembilgileri: [
        { text: this.$t('Hard-Copy-Invoice'), value: 'false' },
        { text: this.$t('Electronic-Invoice'), value: 'true' }
      ],

      cmkodu: ['C', 'M'],
      doviztipi: [],

      vadetipi: [
        { value: 'D', text: this.$t('transfer-date-lesser-than-transfer-date-day') },
        { value: 'D+', text: this.$t('transfer-date-lesser-transfer-date-greater-day') },
        { value: 'D-', text: this.$t('transfer-date-lesser-transfer-date-greater-day') },
        { value: 'E', text: this.$t('transfer-date-lesser-day-next-month-greater') },
        { value: 'E+', text: this.$t('day-the-first-month-number-entered-days') },
        { value: 'E-', text: this.$t('first-month-number-entered-days') },
        { value: 'K', text: this.$t('day-first-month') },
        { value: 'K+', text: this.$t('month-number-entered-days') },
        { value: 'K-', text: this.$t('month-number-entered-days-minus') },
        { value: 'L', text: this.$t('day-first-month-twenty') },
        { value: 'L-', text: this.$t('the-first-month-number-entered-days') },
        { value: 'L+', text: this.$t('first-month-number-entered-days-v2') },
        { value: 'M', text: this.$t('day-of-the-first-month') },
        { value: 'M+', text: this.$t('first-month-number-entered-days-v3') },
        { value: 'M-', text: this.$t('first-month-number-entered-days-v4') },
        { value: 'R', text: this.$t('day-of-if-the-transfer') },
        { value: 'R+', text: this.$t('entered-days-date-lesser-than-day') },
        { value: 'R-', text: this.$t('entered-days-date-lesser-than-day') },
        { value: 'S', text: this.$t('transfer-date-lesser-dayday') },
        { value: 'S+', text: this.$t('number-date-lesser-than-day') },
        { value: 'S-', text: this.$t('number-date-lesser-than-day') },
        { value: 'V', text: this.$t('day-of-the-next-month') },
        { value: 'V+', text: this.$t('next-month-number-entered-days') },
        { value: 'V-', text: this.$t('next-month-number-entered-days-v2') }
      ],

      masrafmerkezi: [],
      dictionary: {
        custom: {
          carikod: {
            required: () => this.$t('This-space-cannot-left-blank'),
          },
          unvan: {
            required: () => this.$t('This-space-cannot-left-blank'),
          },
        }
      },

      text1: '',
      biletlerfaturalanmasin: null,
      efaturamukellefi: false,
      Kdvmuaf: null,
      ciktiistemiyor: null,
      musteribilgitipi: null,
      profilzorunlu: null,
      eventidzorunlu: null,
      snackbar: false,
      y: 'top',
      x: 'right',
      mode: '',
      timeout: 6000,
      active: '0',
      CariDialog: false,
      cariSearch: null,
      icyuzde: false,
      disyuzde: false,
      cariItems: [],
      silinecekIBAN: null
    }
  },

  computed: {
    isDomestic() {
      return this.Current.Type === 'domestic'
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.path
    })
  },

  mounted() {
    this.$validator.localize('en', this.dictionary)

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.PB = credentials.ParaBirimi;
    this.accounting = JSON.parse(window.localStorage.getItem('nextMuhasebe'));

    this.getSirketParameters();

    tool.http_post(this, "UlkeList", {}).then(
      (response) => {
        if (response.body.Status == true) {
          response.body.data.forEach((element) => {
            this.ulkeTipi.push(element.Isim);
          });
        } else {
          this.text1 = "Service Unavailable-country";
          this.snackbar = true;
        }
      },
      () => {
        this.text1 = "Service Unavailable";
        this.snackbar = true;
      }
    );

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, () => {
      this.text1 = 'Service Unavailable'
      this.snackbar = true
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, () => {
      this.text1 = 'Service Unavailable'
      this.snackbar = true
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, () => {
      this.text1 = 'Service Unavailable'
      this.snackbar = true
    })
  },

  methods: {
    IBANGuncelle() {
      this.IBANDialog = false;
    },

    IBANGuncelleAc(item) {
      this.guncelleIBAN = item;
      this.IBANDialog = true;
    },

    IBANEkle() {
  if (this.$refs.formbanka.validate()) {
    var bankinfoekle = {
      IBAN: this.IBANAd,
      SortCode: this.IBANSortCode,
      AccNo: this.IBANAccNo,
      Description: this.IBANDesc,
      Silinecek: false
    }
    this.Current.BankInfo.push(bankinfoekle);
    this.IBANAd = '';
    this.IBANSortCode = '';
    this.IBANAccNo = '';
    this.IBANDesc = '';
  }
},

    IBANSilSor(item) {
      this.dialogsorIBAN = true;
      this.silinecekIBAN = item;
    },

    IBANSil() {
      this.silinecekIBAN.Silinecek = true;
      this.dialogsorIBAN = false;
    },

    getSirketParameters() {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var params = {
        SirketKodu: credentials.SirketKodu
      }

      this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.Current.EInvoiceType = String(response.body.VarsayilanEfaturaTip)
      }, () => {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      })
    },

    selectCari(val) {
      this.Current.Code = val;
      this.CariDialog = false;
    },

    getCariDialog() {
      if (this.Current.Code != null && this.Current.Code != "") {
        this.CariDialog = true;
        this.cariItems = [];
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var current = {
          CompanyCode: credentials.SirketKodu,
          Text: this.Current.Code,
        }

        this.$http.post(auth.API_URL + 'api/Helpers/GetLastCurrentList', current, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.length > 0) {
            response.body.reverse().forEach(element => {
              this.cariItems.push(element);
            });
          }
        }, () => {
          this.text1 = this.$t('The-code-could-not-be-fetched-try-again')
          this.snackbar = true
        })

      } else {
        this.text1 = this.$t('Account-Code-Field-Cannot-be-Empty')
        this.snackbar = true
      }
    },

    applyCode(val) {
      this.Current = {
        ...this.Current,
        ...val,
        Invoice: {
          ...this.Current.Invoice,
          ...(val.Invoice || {})
        }
      }

      if (!this.Current.Type) {
        this.Current.Type = 'domestic'
      }

      this.Current.EInvoiceType = String(val.EInvoiceType || '0')
      this.Current.EInvoiceCustomer = String(val.EInvoiceCustomer || '0')
      this.Current.EArchiveSendType = String(val.EArchiveSendType || 'true')
      this.Current.ProfileForced = String(val.ProfileForced || '0')
      this.Current.EventIDForced = String(val.EventIDForced || '0')

      if (val.TicketBill == '1') this.biletlerfaturalanmasin = true
      else this.biletlerfaturalanmasin = false

      if (val.EInvoiceCustomer == '1') this.efaturamukellefi = true
      else this.efaturamukellefi = false

      if (val.Invoice && val.Invoice.NoPrint == '1') this.ciktiistemiyor = true
      else this.ciktiistemiyor = false

      if (val.ProfileForced == '1') this.profilzorunlu = true
      else this.profilzorunlu = false

      if (val.EventIDForced == '1') this.eventidzorunlu = true
      else this.eventidzorunlu = false
    },

    checkCode() {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      var CurrentInput = {
        Code: this.Current.Code,
        CompanyCode: credentials.SirketKodu
      }

      this.$http.post(auth.API_URL + 'api/Current/Get', CurrentInput, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Title != null) {
          this.applyCode(response.body);
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
        } else {
          this.text1 = response.body.StatusText
        }
        this.snackbar = true
      })
    },

    ItemAktar(value, key) {
      switch (key) {
        case 1:
          var indexAdd = this.itemsSablon.indexOf(value);
          this.itemsSablon.splice(indexAdd, 1);
          this.itemsSablonSelected.push(value);
          break;
        case 2:
          var indexDelete = this.itemsSablonSelected.indexOf(value);
          this.itemsSablonSelected.splice(indexDelete, 1);
          this.itemsSablon.push(value);
          break;
      }
    },

    sablonGetir() {
      if (this.itemsSablonSelected.length <= 0 && this.itemsSablon.length <= 0) {
        tool.api_post(this, "RaporSablon/GetReportBroDesignGrupAll", {
          id: 0,
          ad: 'GenelAmacli',
          objectName: 'Models.GenelAmacliClass'
        }).then(
          response => {
            this.itemsSablon = response.body;
          },
          () => {
            this.text1 = 'Sablon getirilemedi, tekrar deneyiniz.'
            this.snackbar = true
          }
        );
      }
    },

    videoac() {
      this.videodialog = true
    },

    HataYonetimi(response, request, baslik) {
      this.mukellefScroll = false
      if (response.status === 500) {
        this.$refs.hatadialog.open(response, request, baslik);
      } else {
        this.text1 = "Service Unavailable -" + baslik;
        this.snackbar = true;
      }
    },

    soncarikoduGetir() {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      var current = {
        CompanyCode: credentials.SirketKodu,
        Text: this.Current.Code
      }

      this.$http.post(auth.API_URL + 'api/Helpers/GetLastCurrent', current, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.Current.Code = response.body
      }, () => {
        this.text1 = 'Kod getirilemedi, tekrar deneyiniz.'
        this.snackbar = true
      })
    },

    getparabirimi() {
      return helpers.getparabirimi()
    },

    mukellefSorgula() {
      if (!this.isDomestic) return

      if (this.Current.Invoice.TaxNumber && this.Current.Invoice.TaxNumber.length > 1) {
        this.mukellefScroll = true

        let prm = {
          VKN: this.Current.Invoice.TaxNumber
        }

        tool.api_post(this, "EFatura/VKN_Sorgula3", prm).then(
          response => {
            this.mukellefScroll = false
            this.postaitems = []

            if (response.body.Status == true) {
              if (response.body.data.length > 0) {
                this.efaturamukellefi = true

                if (response.body.data.length > 1) {
                  this.cokluposta = true
                  response.body.data.forEach(element => {
                    this.postaitems.push(element.alias)
                  });
                  this.Current.PostCodeLabel = response.body.data[0].alias
                } else {
                  this.cokluposta = false
                  this.Current.PostCodeLabel = response.body.data[0].alias
                }
              } else {
                this.text1 = this.$t('No-liable-found')
                this.snackbar = true
              }
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
            }
          },
          response => {
            this.HataYonetimi(response, prm, 'Mükellef Sorgulanamadı');
          }
        );
      } else {
        this.text1 = this.$t('Please-Enter-Your-Digit-Taxation-Number')
        this.snackbar = true
      }
    },

    ekle() {
      this.$validator.validateAll().then((result) => {
        if (!result) return;

        var selectedItems = [];
        this.itemsSablonSelected.forEach(element => {
          selectedItems.push({
            TemplateId: element.id,
            TemplateName: element.ad
          });
        });
        this.Current.CustomReportTemplate = selectedItems;

        this.loadingvmodel = true

        this.Current.TicketBill = this.biletlerfaturalanmasin ? '1' : '0'
        this.Current.EInvoiceCustomer = this.efaturamukellefi ? '1' : '0'
        this.Current.Invoice.NoPrint = this.ciktiistemiyor ? '1' : '0'
        this.Current.ProfileForced = this.profilzorunlu ? '1' : '0'
        this.Current.EventIDForced = this.eventidzorunlu ? '1' : '0'

        this.Current.CurrentServicePrice = [
  {
    Kod: 11,
    Fiyat: this.ServisParametre.Fiyat11 || 0,
    Dvz: this.ServisParametre.Doviztip11 || ''
  },
  {
    Kod: 12,
    Fiyat: 0,
    Dvz: this.ServisParametre.Doviztip11 || ''
  },
  {
    Kod: 13,
    Fiyat: 0,
    Dvz: this.ServisParametre.Doviztip11 || ''
  },
  {
    Kod: 15,
    Fiyat: 0,
    Dvz: this.ServisParametre.Doviztip11 || ''
  },
  {
    Kod: 19,
    Fiyat: 0,
    Dvz: this.ServisParametre.Doviztip11 || ''
  },
  {
    Kod: 21,
    Fiyat: this.ServisParametre.Fiyat21 || 0,
    Dvz: this.ServisParametre.Doviztip21 || ''
  },
  {
    Kod: 22,
    Fiyat: 0,
    Dvz: this.ServisParametre.Doviztip21 || ''
  },
  {
    Kod: 31,
    Fiyat: 0,
    Dvz: this.ServisParametre.Doviztip21 || ''
  },
  {
    Kod: 32,
    Fiyat: 0,
    Dvz: this.ServisParametre.Doviztip21 || ''
  },
  {
    Kod: 33,
    Fiyat: 0,
    Dvz: this.ServisParametre.Doviztip21 || ''
  },
  {
    Kod: 40,
    Fiyat: 0,
    Dvz: this.ServisParametre.Doviztip21 || ''
  },
  {
    Kod: 44,
    Fiyat: 0,
    Dvz: this.ServisParametre.Doviztip21 || ''
  }
];


        
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.Current.CompanyCode = this.tumsirketler ? 0 : credentials.SirketKodu

      

        this.$http.post(auth.API_URL + 'api/Current/New', this.Current, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.loadingvmodel = false

          if (response.body.Status === true) {
            
            this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
          } else {
            this.text1 = response.body.ErrorList ? response.body.ErrorList[0] : 'Kayıt sırasında hata oluştu'
            this.snackbar = true
          }
        }, () => {
          this.loadingvmodel = false
          this.text1 = 'Hata Oluştu, tekrar deneyiniz'
          this.snackbar = true
        })
      })
    }
  },

  components: {
    parainput,
    yuzdeinput,
    hatadialog,
    cariaracomp,
    analizcomp,
    loadingcomp,
    muhasebekoducomp,
    snackbarcomp
  },

  watch: {
    'icYuzdedenHesapla.Yuzdeden': function (value) {
      if (value == true) {
        this.icyuzde = true
        this.icYuzdedenHesapla.HesapTipi = 0
      } else {
        this.icyuzde = false
        this.icYuzdedenHesapla.HesapTipi = null
      }
    },

    'DisYuzdedenHesapla.Yuzdeden': function (value) {
      if (value == true) {
        this.disyuzde = true
        this.DisYuzdedenHesapla.HesapTipi = 0
      } else {
        this.disyuzde = false
        this.DisYuzdedenHesapla.HesapTipi = null
      }
    },

    'Current.Type': function (val) {
      if (val === 'international') {
        this.efaturamukellefi = false
        this.Current.EInvoiceCustomer = '0'
      }
    }
  }
}
</script>

<style scoped>
.modern-page {
  min-height: 100vh;
  padding: 20px;
  background:
    radial-gradient(circle at top left, rgba(37, 99, 235, 0.10), transparent 28%),
    radial-gradient(circle at top right, rgba(14, 165, 233, 0.10), transparent 24%),
    linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
}

.page-shell {
  background: transparent !important;
}

.hero-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
  padding: 24px 28px;
  margin-bottom: 18px;
  border-radius: 24px;
  background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 60%, #0ea5e9 100%);
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.18);
}

.hero-badge {
  display: inline-block;
  margin-bottom: 10px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  color: #dbeafe;
  background: rgba(255,255,255,0.14);
}

.hero-title {
  margin: 0;
  color: #fff;
  font-size: 28px;
  font-weight: 800;
}

.hero-subtitle {
  margin-top: 6px;
  color: rgba(255,255,255,0.80);
  font-size: 14px;
}

.hero-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.hero-checkbox {
  color: #fff !important;
}

.save-btn {
  border-radius: 14px !important;
  text-transform: none !important;
  font-weight: 700;
  background: #fff !important;
  color: #0f172a !important;
}

.icon-btn {
  color: #fff !important;
}

.modern-tabs .v-tabs__bar {
  background: rgba(255,255,255,0.72) !important;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 18px;
  backdrop-filter: blur(10px);
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
  margin-bottom: 18px;
}

.modern-tabs .v-tab {
  text-transform: none !important;
  font-weight: 700;
  color: #334155 !important;
}

.tab-pane {
  padding-top: 8px;
}

.content-card,
.dialog-card,
.sub-card {
  border-radius: 22px !important;
  border: 1px solid rgba(148, 163, 184, 0.16);
  background: rgba(255,255,255,0.88) !important;
  backdrop-filter: blur(10px);
  box-shadow: 0 12px 35px rgba(15, 23, 42, 0.08);
}

.section-head {
  padding: 22px 24px 10px;
}

.section-head h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: #0f172a;
}

.section-head span {
  display: block;
  margin-top: 4px;
  font-size: 13px;
  color: #64748b;
}

.modern-field {
  margin-bottom: 10px;
}

.modern-check {
  margin-top: 4px !important;
}

.last-code-wrap {
  display: flex;
  align-items: center;
  height: 100%;
  padding-top: 4px;
}

.template-row {
  padding: 10px 0;
  border-bottom: 1px solid rgba(226, 232, 240, 0.7);
}

.query-btn {
  margin-top: 8px;
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 700;
}

@media (max-width: 960px) {
  .hero-bar {
    flex-direction: column;
    align-items: flex-start;
  }

  .hero-actions {
    width: 100%;
    flex-wrap: wrap;
  }
}
</style>